import { render, staticRenderFns } from "./dybgTable.vue?vue&type=template&id=2ba685ba&scoped=true&"
import script from "./dybgTable.vue?vue&type=script&lang=js&"
export * from "./dybgTable.vue?vue&type=script&lang=js&"
import style0 from "./dybgTable.vue?vue&type=style&index=0&id=2ba685ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba685ba",
  null
  
)

export default component.exports